import script from "./AllOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./AllOrder.vue?vue&type=script&setup=true&lang=js"

import "./AllOrder.vue?vue&type=style&index=0&id=707d88dd&lang=css"

const __exports__ = script;

export default __exports__